import styled, { css } from 'styled-components'

import { buttonColorCSS } from './utils'
import { BaseButton } from '../BaseButton'

export const SecondaryButtonStyled = styled(BaseButton)`
  ${(props) => {
    const button = props.theme.colors.button.secondary

    return css`
      ${buttonColorCSS(button, {
        loader: {
          background: button.background.disabled,
          color: button.content.disabled,
        },
      })}

      &:active {
        box-shadow: none;
      }
    `
  }}
`
